<template>
  <div class="reviews-container">
    <h1 class="reviews-title">Why Families Love Us</h1>
    <div class="reviews-content">
      <!-- 左侧评分总览 -->
      <div class="rating-overview">
        <div class="rating-box">
          <h2>Excellent</h2>
          <div class="stars">
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
            <i class="fas fa-star"></i>
            <i class="fas fa-star-half-alt"></i>
          </div>
          <div class="rating-score">4.93 average</div>
          <div class="total-reviews">15,515 reviews</div>
        </div>
      </div>

      <!-- 右侧评价轮播 -->
      <div class="reviews-carousel">
        <div class="carousel-container" ref="carousel">
          <div class="review-slide" v-for="(review, index) in visibleReviews" :key="index">
            <div class="review-card">
              <div class="review-header">
                <h3>{{ review.name }}</h3>
                <!-- <div class="verified-badge">
                  <i class="fas fa-check-circle"></i>
                  Verified Customer
                </div> -->
              </div>
              <div class="review-stars">
                <i class="fas fa-star" v-for="n in 5" :key="n"></i>
              </div>
              <p class="review-text">{{ review.content }}</p>
              <div class="review-date">{{ review.date }}</div>
            </div>
          </div>
        </div>
        <div class="carousel-controls">
          <button class="prev-btn" @click="prevSlide"><i class="fas fa-chevron-left"></i></button>
          <button class="next-btn" @click="nextSlide"><i class="fas fa-chevron-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Reviews',
  data() {
    return {
      currentIndex: 0,
      reviews: [
        {
          name: 'Gabriel J',
          content: 'She tutored me last year in May. She was an amazing tutor; she helped me get better at reading.',
          date: '16 hours ago'
        },
        {
          name: 'Sarah L',
          content: 'Excellent teaching methods and very patient. Helped me improve my IELTS score significantly.',
          date: '2 days ago'
        },
        {
          name: 'Michael W',
          content: 'Professional and knowledgeable. The legal English course was exactly what I needed.',
          date: '1 week ago'
        },
        {
          name: 'Emma T',
          content: 'Great experience! The personalized study plan really helped me stay focused.',
          date: '2 weeks ago'
        },
        {
          name: 'David R',
          content: 'Very structured approach to IELTS preparation. Highly recommended!',
          date: '3 weeks ago'
        },
        {
          name: 'Olivia M',
          content: 'The course was well-organized and the tutor was very supportive. I was able to improve my English skills significantly through this course.',
          date: '2 months ago'
        }
      ]
    }
  },
  computed: {
    visibleReviews() {
      // 修改这里以处理循环逻辑
      const reviews = [...this.reviews]
      // 添加前三个评论到末尾以实现无缝循环
      reviews.push(...this.reviews.slice(0, 3))
      return reviews.slice(this.currentIndex, this.currentIndex + 4)
    }
  },
  methods: {
    startCarousel() {
      setInterval(() => {
        this.nextSlide()
      }, 2000)
    },
    nextSlide() {
      // 修改为完全循环逻辑
      this.currentIndex = (this.currentIndex + 1) % this.reviews.length
    },
    prevSlide() {
      // 修改为完全循环逻辑
      this.currentIndex = this.currentIndex === 0 
        ? this.reviews.length - 1 
        : this.currentIndex - 1
    }
  },
  mounted() {
    this.startCarousel()
  }
}
</script>

<style scoped>
.reviews-container {
  padding: 2rem;
  background-color: #fff;
}

.reviews-title {
  text-align: center;
  margin-bottom: 2rem;
  color: #2c3e50;
  font-size: 2.5rem;
  font-weight: bold;
}

.reviews-content {
  display: flex;
  max-width: 90%;
  margin: 0 auto;
  gap: 4rem;  /* 从2rem增加到4rem */
}

.rating-overview {
  flex: 1;
  max-width: 18%;
  background-color: #3f51b5;
  color: white;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
}

.reviews-carousel {
  flex: 4;  /* 从3改为4 */
  position: relative;
  overflow: hidden;
}

.review-slide {
  flex: 0 0 calc(25% - 1rem);  /* 保持不变，因为这是每个评论卡片的宽度 */
  margin-right: 1rem;
}

.rating-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.rating-box h2 {
  font-size: 2rem;
  margin: 0;
}

.stars {
  color: #ffd700;
  font-size: 1.5rem;
}

.rating-score {
  font-size: 1.5rem;
  font-weight: bold;
}

.total-reviews {
  font-size: 1rem;
  opacity: 0.9;
}

.reviews-carousel {
  flex: 3;
  position: relative;
  overflow: visible;
}


.review-slide {
  flex: 0 0 calc(25% - 1rem);
  margin-right: 1rem;
}

.review-card {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  height: 320px; /* 固定高度 */
  display: flex;
  flex-direction: column;
}

.review-header h3 {
  margin: 0;
  font-size: 1.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-text {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
  flex-grow: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制显示3行 */
  -webkit-box-orient: vertical;
}

.carousel-container {
  overflow: hidden;  /* 将 overflow: hidden 移到这里 */
  display: flex;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-slide {
  flex: 0 0 calc(25% - 1rem);
  margin-right: 1rem;
  opacity: 1;
  transform: scale(1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-slide.entering {
  opacity: 0;
  transform: translateX(50px);
}

.review-slide.leaving {
  opacity: 0;
  transform: translateX(-50px);
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.review-header h3 {
  margin: 0;
  font-size: 1.1rem;
}

.verified-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4caf50;
  font-size: 0.9rem;
}

.review-stars {
  color: #ffd700;
  margin-bottom: 1rem;
}

.review-text {
  color: #666;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.review-date {
  color: #999;
  font-size: 0.9rem;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  width: 108%;
  left: -4.2%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  z-index: 2;  /* 确保按钮在最上层 */
}

.prev-btn,
.next-btn {
  background-color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  pointer-events: auto;
}

.prev-btn:hover,
.next-btn:hover {
  background-color: #f8f9fa;
}

@media (max-width: 768px) {
  .reviews-content {
    flex-direction: column;
  }

  .rating-overview {
    max-width: 100%;
  }

  .review-slide {
    flex: 0 0 100%;
  }
}
</style>